export default "__VITE_ASSET__a5012fe8__"